export default __webpack_public_path__ + "static/media/ITRealCase.5e4b20f1.svg";